import React, { useRef } from "react";
import Slider from "react-slick";
// import 'slick-carousel/slick/slick.css';// import 'slick-carousel/slick/slick-theme.css';

const Carrusel = ({
  items,
  slidesToShow = 3,
  slidesToScroll = 1,
  autoplay = false,
  autoplaySpeed = 3000,
  dots = false,
  infinite = true,
  arrows = false,
  responsive = [],
}) => {
  // console.log(responsive);
  
  let sliderRef = useRef(null);

  const settings = {
    dots,
    infinite,
    speed: 500,
    slidesToShow,
    slidesToScroll,
    autoplay,
    autoplaySpeed,
    arrows,
    responsive:
      responsive.length > 0
        ? responsive
        : [
          {
              breakpoint: 1368 ,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: false,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 1023,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
  };
  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };
  return (
    <div className=" flex flex-row items-center w-full md:w-full xl:w-full justify-between mx-auto">
      <button className=" flex-none w-fit" onClick={previous}>
        <Prev />
      </button>
      <div className="flex-grow sm:flex-none w-[70%] sm:w-[90%] md:w-[85%] lg:w-[90%] xl:w-[85%] ">
        <Slider
          ref={(slider) => {
            sliderRef = slider;
          }}
          {...settings}
        >
          {items.map((item, index) => (
            <div key={index} className="p-1 xl:p-1 2xl:p-2">
              {item}
            </div>
          ))}
        </Slider>
      </div>
      <button className="flex-none w-fit" onClick={next}>
        <Next />
      </button>
    </div>
  );
};

export default Carrusel;

function Next() {
  return (
    <div className="w-full h-full rounded-full overflow-hidden bg-primario">
      <svg
        className="w-8 sm:w-10 xl:h-14 p-2 xl:w-14 "
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 640"
      >
        <path
          fill="#ffff86"
          d="M566.6 342.6C579.1 330.1 579.1 309.8 566.6 297.3L406.6 137.3C394.1 124.8 373.8 124.8 361.3 137.3C348.8 149.8 348.8 170.1 361.3 182.6L466.7 288L96 288C78.3 288 64 302.3 64 320C64 337.7 78.3 352 96 352L466.7 352L361.3 457.4C348.8 469.9 348.8 490.2 361.3 502.7C373.8 515.2 394.1 515.2 406.6 502.7L566.6 342.7z"
        />
      </svg>
    </div>
  );
}

function Prev() {
  return (
    <div className="w-full h-full rounded-full overflow-hidden bg-primario">
      <svg
        className="w-8 sm:w-10 xl:h-14 p-2 xl:w-14"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 640"
      >
        <path
          fill="#ffff86"
          d="M73.4 297.4C60.9 309.9 60.9 330.2 73.4 342.7L233.4 502.7C245.9 515.2 266.2 515.2 278.7 502.7C291.2 490.2 291.2 469.9 278.7 457.4L173.3 352L544 352C561.7 352 576 337.7 576 320C576 302.3 561.7 288 544 288L173.3 288L278.7 182.6C291.2 170.1 291.2 149.8 278.7 137.3C266.2 124.8 245.9 124.8 233.4 137.3L73.4 297.3z"
        />
      </svg>
    </div>
  );
}
